/* NOMI v23.9/v23.10 — phone-frame videos (sample page, recipes). Each autoplays muted
   (browsers require it); its pill toggles sound, and turning one on mutes the others.
   Paused when scrolled out of view or the tab is hidden; reduced-motion gets controls. */
(function () {
  var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-bs-phone]'));
  if (!boxes.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var all = [];
  boxes.forEach(function (box) {
    var video = box.querySelector('video');
    var btn = box.querySelector('[data-bs-sound]');
    if (!video) return;
    var st = { box: box, video: video, btn: btn, wanted: !reduce };
    all.push(st);
    function setSound(on) {
      video.muted = !on;
      if (on) { video.volume = 1; video.play().catch(function () {}); all.forEach(function (o) { if (o !== st && !o.video.muted) { o.video.muted = true; if (o.btn) o.btn.setAttribute('aria-pressed', 'false'); } }); }
      if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    if (btn) btn.addEventListener('click', function () { setSound(video.muted); });
    if (reduce) { video.pause(); video.removeAttribute('autoplay'); video.controls = true; return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { video.play().catch(function () {}); } else { video.pause(); } });
      }, { threshold: 0.25 }).observe(box);
    }
  });
  document.addEventListener('visibilitychange', function () {
    all.forEach(function (o) { if (document.hidden) o.video.pause(); else if (o.wanted) o.video.play().catch(function () {}); });
  });
})();

/* v23.66: the sample gate. Four required fields; the mobile number is normalised to +1XXXXXXXXXX
   (US) before it posts, and a sample-phone-<digits> tag rides along so a repeat claim is one search
   away in Shopify admin (Customers > search the tag). */
(function () {
  var form = document.querySelector('[data-sample-gate]');
  if (!form) return;
  var phone = form.querySelector('[data-gate-phone]');
  var tags = form.querySelector('[data-gate-tags]');
  var consent = form.querySelector('[data-gate-consent]');
  function digits(v) { return String(v || '').replace(/\D+/g, ''); }
  function normalise() {
    if (!phone) return true;
    var d = digits(phone.value);
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length !== 10 || /^[01]/.test(d)) { phone.setCustomValidity('Enter a 10-digit US mobile number.'); return false; }
    phone.setCustomValidity('');
    phone.value = '+1' + d;
    if (tags) { var base = tags.value.replace(/,?sample-phone-\d+/g, ''); tags.value = base + ',sample-phone-1' + d; }
    return true;
  }
  if (phone) phone.addEventListener('input', function () { phone.setCustomValidity(''); });
  if (consent) consent.addEventListener('change', function () { consent.setCustomValidity(consent.checked ? '' : 'The newsletter is part of the free sample.'); });
  form.addEventListener('submit', function (ev) {
    var ok = normalise();
    if (consent && !consent.checked) { consent.setCustomValidity('The newsletter is part of the free sample.'); ok = false; }
    if (!ok || !form.checkValidity()) { ev.preventDefault(); form.reportValidity(); return; }
    // v23.78: remember the submit so a detour (Shopify's spam check, a lost referrer) still lands back here
    try { sessionStorage.setItem('nomi_sample_submit', String(Date.now())); } catch (e) {}
  });
  // v23.78: back from a successful submit but the page rendered the form again -> show the unlock step
  if (/[?&]customer_posted=true/.test(location.search)) {
    var done = document.querySelector('[data-gate-done]');
    if (done && !form.querySelector('.errors')) { form.hidden = true; done.hidden = false; }
    try { sessionStorage.removeItem('nomi_sample_submit'); } catch (e) {}
  }
})();
